import { useTranslation } from "@redotech/redo-i18n";
import type { SeparateLabelsState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SeparateLabelsDetails = memo(function SeparateLabelsDetails(
  _props: StepTypeDetailsProps<SeparateLabelsState>,
) {
  const { t } = useTranslation();
  return (
    <Text fontSize="xs">
      {t("This step will create an individual shipping label for each item.")}
    </Text>
  );
});
